import { auth } from "@/features/auth/providers/firebase"
import { getAppleToken } from "@/shared/lib/apple-identity"

import { userService } from "./api/user-service"
import { writeUserProfileCache } from "./hooks/use-user-profile"
import type { UserProfile, UserProfileInput } from "./types"

/**
 * Persist the signed-in user's profile to `POST /v1/users/me` and refresh the
 * in-memory `/me` cache so profile UI reads the saved values.
 */
export async function updateCurrentUserProfile(
  input: UserProfileInput,
): Promise<UserProfile> {
  if (!userService.isConfigured) {
    throw new Error("User API is not configured")
  }

  const current = auth.currentUser
  if (!current) {
    throw new Error("Not signed in")
  }

  const appleToken = getAppleToken(current)
  const token = await current.getIdToken()
  const updated = await userService.upsertMe(token, {
    ...input,
    ...(appleToken ? { appleToken } : {}),
  })

  writeUserProfileCache(current.uid, updated)
  return updated
}
